import request from "../utils/request";

export function GET_HolidayList(token, year) {
  return request.get(`/Holiday/List/${year}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Holiday(token, payload) {
  return request.post("/Holiday", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Holiday(token, payload) {
  return request.delete("/Holiday", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
